import debounce from './debounce';
import throttle from './throttle';
import { animate } from 'motion';

const OrangeSection = () => {
  let windowWidth = window.innerWidth;
  const orangeSectionStart = document.querySelectorAll('.orange-section-start');
  const orangeSectionEnd = document.querySelectorAll('.orange-section-end');
  const orangeSection = document.querySelectorAll('.orange-section');

  const mouse = document.querySelectorAll('.mouse');

  const hasPointer = window.matchMedia('(pointer:fine)').matches;

  const positionSection = (startSect, endSect, orangeSect) => {
    let height = 0;

    const orangeSectionStartRect = startSect.getBoundingClientRect();

    if (orangeSectionEnd) {
      const orangeSectionEndRect = endSect?.getBoundingClientRect() ?? orangeSectionStartRect;
      height = orangeSectionEndRect.bottom - orangeSectionStartRect.top;
    } else {
      height = document.documentElement.offsetHeight - orangeSectionStartRect.top;
    }

    orangeSect.style.height = `${height}px`;
    orangeSect.style.top = `${orangeSectionStart.offsetTop}px`;
  };

  const configureSections = () => {
    orangeSectionStart.forEach((startSect, i) => {
      const endSect = orangeSectionEnd[i];
      const orangeSect = startSect.nextElementSibling;

      positionSection(startSect, endSect, orangeSect);
    });
  };

  let timeout = 100;

  const media = window.matchMedia('(min-width: 1024px)');

  if (media.matches) {
    timeout = 1000;
  }

  const onResize = debounce(() => {
    if (windowWidth !== window.innerWidth) {
      configureSections();
    }
  }, timeout);

  if (orangeSectionStart) {
    setTimeout(() => {
      configureSections();
    }, timeout);

    window.addEventListener('resize', onResize);
  }

  //if (mouse && hasPointer) {
  //  mouse.forEach((m) => {
  //    let speed = 0.01;
  //    let mouseX = 0;
  //    let mouseY = 0;
  //    let ballX = 0;
  //    let ballY = 0;
  //    const orgSect = m.closest('.orange-section');

  //    let orgSectOffsetTop = orgSect.offsetTop;

  //    if (orgSectOffsetTop === 0) {
  //      const parent = orgSect.parentElement;

  //      orgSectOffsetTop = parent.offsetTop;
  //    }

  //    const animate = () => {
  //      const distX = mouseX - ballX;
  //      const distY = mouseY - ballY;

  //      ballX = ballX + distX * speed;
  //      ballY = ballY + distY * speed;

  //      m.style.left = `${ballX}px`;
  //      m.style.top = `${ballY}px`;
  //      //mouse.style.transform = `rotate(${ballX / 10}deg)`;

  //      requestAnimationFrame(animate);
  //    };

  //    animate();

  //    document.addEventListener('mousemove', (e) => {
  //      // position cursor but take into account scroll position
  //      mouseX = e.clientX;
  //      mouseY = e.clientY - orgSectOffsetTop;

  //      // Get the window scroll position
  //      const scrollX = window.scrollX || document.documentElement.scrollLeft;
  //      const scrollY = window.scrollY || document.documentElement.scrollTop;

  //      // Update the position of the followDiv
  //      mouseX = mouseX + scrollX;
  //      mouseY = mouseY + scrollY;
  //    });
  //  });
  //}
};

export default OrangeSection;
